<template>
    <landlords-current
        v-slot="{
            data: landlord
        }"
    >
        <with-variables
            :variables="{
                contact: _.get(jobSheet, 'contacts.data[0]')
            }"
            v-slot="{ contact }"
        >
            <div>
                <base-svg
                    name="icon-phone-ring"
                    class="absolute top-0 left-0 w-6 h-6"
                    :class="{
                        'fill-primary-blue fill-secondary-blue-lighter': _.isNull(entry.persona)
                    }"
                />

                <header>
                    <h6>
                        <template v-if="landlord && entry.persona && entry.persona.type === landlord.type && landlord.uuid === entry.persona.uuid">
                            You left your contact details
                        </template>
                        <template v-else>
                            {{ _.get(entry, 'persona.first_name', contact.name) }} left their contact details
                        </template>
                    </h6>

                    <span class="text-label">{{ entry.created_at | moment('HH:mm:ss DD/MM/YYYY') }}</span>
                </header>

                <div class="mt-1 text-grey-darker">
                    <p class="mb-3">
                        The landlord of the property has shared this job sheet with you. Their contact details are:
                    </p>

                    <a-mailto
                        :email="entry.email"
                        class="block text-blue"
                    />

                    <a-tel
                        :telephone="entry.telephone"
                        class="block mb-1 text-blue"
                    />
                </div>
            </div>
        </with-variables>
    </landlords-current>
</template>

<script>
    import LandlordsCurrent from './landlords-current'

    export default {
        components: {
            LandlordsCurrent
        },
        props: {
            jobSheet: {
                type: Object,
                required: true
            },
            entry: {
                type: Object,
                required: true
            }
        },
        computed: {
            job_sheet () {
                return this.jobSheet
            }
        }
    }
</script>
